/* eslint react/no-unused-prop-types: "off" */
import React from 'react'
import Color from 'color'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { MediaQuery, HoverMenuItem } from '..'
import { Collapse } from 'react-collapse'
import * as styles from './styles'
import variables from '../../styles/variables'
import logo from '../../../assets/aito-logo.svg'
import closeIcon from '../../../assets/icons/close.svg'

const burgerMenuStyles = (barColor) => {
  return (
    {
      bmBurgerButton: {
        position: 'fixed',
      },
      bmCrossButton: {
        height: '32px',
        width: '32px',
        top: '20px',
        right: '30px',
        padding: '20px',
      },
      bmCross: {
        height: '36px',
        width: '36px',
      },
      bmBurgerBars: {
        height: '4px',
        background: barColor
      },
    }
  )
}

const navItems = [
  {
    id: 1,
    menu: 'Company',
    type: 'hover',
    links: [
      {
        text: 'About us',
        url: '/company/'
      },
      {
        text: 'Join us',
        url: '/company/join-us/'
      }
    ]
  },
  {
    id: 2,
    menu: 'Product',
    type: 'hover',
    links: [
      {
        text: 'Why Aito',
        url: '/product/'
      },
      {
        text: 'Use cases',
        url: '/product/use-cases/'
      },
      {
        text: 'Example gallery',
        url: '/example-gallery/'
      },
      {
        text: 'FAQ',
        url: '/product/faq/'
      }
    ]
  },
  {
    id: 3,
    menu: 'Developers',
    type: 'hover',
    links: [
      {
        text: 'Documentation',
        url: '/docs/'
      },
      {
        text: 'Hello world tutorial',
        url: '/docs/articles/hello-world-tutorial/'
      },
      {
        text: 'API reference',
        url: '/docs/api/',
        external: true
      },
      {
        text: 'Release notes',
        url: '/release-notes/'
      }
    ]
  },
  {
    id: 4,
    menu: 'Blog',
    type: 'link',
    url: '/blog/'
  },
  {
    id: 5,
    menu: 'Pricing',
    type: 'link',
    url: '/pricing/'
  },
  {
    id: 6,
    menu: 'Try it out',
    type: 'button',
    url: '/request-trial/'
  }
]

const propTypes = {
  background: PropTypes.string,
  textColor: PropTypes.string,
  slideOut: PropTypes.bool,
  showSlideOut: PropTypes.bool,
}

const defaultProps = {
  background: '',
  textColor: variables.colors.silverTree.medium,
  slideOut: false,
  showSlideOut: false,
}

export default class NavBar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      openMenuId: null,
      isOpen: false
    }
  }

  toggleCollapseMenu = (menuId) => {
    this.setState((prevState) => {
      if (prevState.openMenuId !== menuId) {
        return {
          openMenuId: menuId,
          isOpen: true
        }
      }
      return {
        isOpen: !prevState.isOpen
      }
    })
  }

  render() {
    const { openMenuId, isOpen } = this.state
    const { background, textColor, slideOut, showSlideOut } = this.props

    return (
      <nav className="NavBar">
        <styles.Container
          backgroundColor={background}
          slideOut={slideOut}
          showSlideOut={showSlideOut}
        >
          <styles.SubContainer>
            <styles.LogoContainer>
              <Link to="/"><styles.Logo src={logo} alt="Aito" /></Link>
            </styles.LogoContainer>

            <MediaQuery query={variables.media.sm}>
              {(matches) => {
                if (matches) {
                  return (
                    <styles.LinkWrapper textColor={textColor}>
                      <styles.LinkList textColor={textColor}>
                        {_.map(navItems, (item, index) => {
                          if (item.type === 'hover') {
                            return (
                              <li key={index}>
                                <styles.HoverMenu
                                  slideOut={slideOut}
                                  showSlideOut={showSlideOut}
                                  backgroundColor={
                                    slideOut
                                      ? Color(variables.colors.sunsetOrange.lighter)
                                        .lighten(0.05)
                                        .string()
                                      : variables.colors.sunsetOrange.lighter
                                  }
                                  component={(
                                    <styles.Padded>
                                      <styles.ExpandableMenuItem>
                                        {item.menu}
                                        <styles.ExpandableMenuItemChevron />
                                      </styles.ExpandableMenuItem>
                                    </styles.Padded>
                                  )}
                                >
                                  {_.map(item.links, (link, i) => {
                                    return (
                                      <HoverMenuItem
                                        external={link.external}
                                        key={i}
                                        to={link.url}
                                      >
                                        {link.text}
                                      </HoverMenuItem>
                                    )
                                  })}
                                </styles.HoverMenu>
                              </li>
                            )
                          }
                          if (item.type === 'button') {
                            return (
                              <li key={index}>
                                <Link to={item.url}>
                                  <styles.Button
                                    type="outline"
                                    buttonColor={textColor}
                                    textColor={textColor}
                                    size="small"
                                  >
                                    {item.menu}
                                  </styles.Button>
                                </Link>
                              </li>
                            )
                          }
                          return (
                            <li key={index}>
                              <Link to={item.url}>
                                <styles.Padded>{item.menu}</styles.Padded>
                              </Link>
                            </li>
                          )
                        })}
                      </styles.LinkList>
                    </styles.LinkWrapper>
                  )
                }

                return (
                  <div>
                    <span>
                      <styles.BurgerMenu
                        customCrossIcon={<img src={closeIcon} alt="close" />}
                        styles={burgerMenuStyles(textColor)}
                        right
                      >
                        {_.map(navItems, (item, index) => {
                          if (item.type === 'hover') {
                            const openMenu = item.id === openMenuId && isOpen
                            return (
                              <div key={index}>
                                <styles.BurgerMenuHeader
                                  onClick={() => this.toggleCollapseMenu(item.id)}
                                >
                                  {item.menu}
                                  <styles.Chevron direction={openMenu ? 'up' : 'down'} />
                                </styles.BurgerMenuHeader>
                                <Collapse isOpened={openMenu}>
                                  {_.map(item.links, (link, i) => {
                                    return (
                                      <styles.BurgerMenuLinkSmall
                                        external={link.external}
                                        to={link.url}
                                        key={i}
                                      >
                                        {link.text}
                                      </styles.BurgerMenuLinkSmall>
                                    )
                                  })}
                                </Collapse>
                              </div>
                            )
                          }
                          return (
                            <styles.BurgerMenuLink to={item.url} key={index}>
                              {item.menu}
                            </styles.BurgerMenuLink>
                          )
                        })}
                      </styles.BurgerMenu>
                    </span>
                  </div>
                )
              }}
            </MediaQuery>
          </styles.SubContainer>
        </styles.Container>
      </nav>
    )
  }
}

NavBar.propTypes = propTypes
NavBar.defaultProps = defaultProps
